import React from 'react';
import { ReactComponent as ExclamationIcon } from '@blink/assets/src/icons/exclamation.svg';

import { usePoolDetailsStyle } from '@/pages/Pool/Pool.style';
import { ClientPool } from '@/shared/api/borrow';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@/shared/ui';
import { cn } from '@/shared/lib/tailwind-merge';

interface PoolDetailsPanelProps {
    clientPool: ClientPool;
}
export const PoolDetailsPanel: React.FC<PoolDetailsPanelProps> = ({ clientPool }) => {
    const classes = usePoolDetailsStyle();

    return (
        <div className={classes.main}>
            <div className={classes.tableWrapper}>
                <table className={classes.table}>
                    <thead>
                        <tr className={classes.tr}>
                            <th className={`${classes.asset}`}>Pool Information</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr className={`${classes.tr}`}>
                            <td className={classes.firstTd}>
                                <div className={classes.param}>
                                    <div className='flex items-center gap-2'>
                                        <div data-testid='details-liquidation-label'>
                                            Liquidation Fee
                                        </div>
                                        <TooltipProvider>
                                            <Tooltip>
                                                <TooltipTrigger asChild>
                                                    <ExclamationIcon />
                                                </TooltipTrigger>
                                                <TooltipContent side='bottom' sideOffset={30}>
                                                    <p data-testid='details-tooltip-liquidation-content'>
                                                        A penalty charged when your position is
                                                        liquidated due to insufficient collateral.
                                                    </p>
                                                </TooltipContent>
                                            </Tooltip>
                                        </TooltipProvider>
                                    </div>
                                    <div
                                        className={classes.subtitle}
                                        data-testid='details-liquidation-value'
                                    >{`${clientPool.liquidationFee}%`}</div>
                                </div>
                            </td>
                        </tr>
                        <tr className={`${classes.tr}`}>
                            <td className={classes.firstTd}>
                                <div
                                    className={classes.param}
                                    data-testid='details-risk-factor-label'
                                >
                                    Risk Factor values
                                </div>
                                <div
                                    data-testid='details-margin-call-value'
                                    className={cn(classes.subtitle, 'flex justify-between')}
                                >
                                    <div>Margin Call</div>
                                    <div>{clientPool.marginCallThreshold}</div>
                                </div>
                                <div
                                    className={cn(classes.subtitle, 'flex justify-between')}
                                    data-testid='details-liquidation-threshold-value'
                                >
                                    <div>Liquidation</div>
                                    <div>{clientPool.liquidationThreshold}</div>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    );
};
